import * as z from 'zod';

export const EventKindSchema = z.enum(['STANDARD', 'RACE'])

export type EventKind = z.infer<typeof EventKindSchema>;